import { Button } from '@/components/ui/button';
import type { NavPeriod } from './NavChart';

interface TimelineToggleProps {
  periods: NavPeriod[];
  selected: NavPeriod;
  onChange: (period: NavPeriod) => void;
}

export function TimelineToggle({ periods, selected, onChange }: TimelineToggleProps) {
  return (
    <div className="flex flex-wrap gap-1" role="group" aria-label="NAV history time period">
      {periods.map((period) => (
        <Button
          key={period}
          variant={period === selected ? 'default' : 'outline'}
          size="sm"
          onClick={() => onChange(period)}
          aria-pressed={period === selected}
        >
          {period}
        </Button>
      ))}
    </div>
  );
}
